import React, {Component} from 'react'
import AmCharts from "@amcharts/amcharts3-react";


// Generate random data
// function generateData() {
//     var firstDate = new Date();
//
//     var dataProvider = [];
//
//     for (var i = 0; i < 100; ++i) {
//         var date = new Date(firstDate.getTime());
//
//         date.setDate(i);
//
//         dataProvider.push({
//             date: date,
//             value: Math.floor(Math.random() * 100)
//         });
//     }
//
//     return dataProvider;
// }

class PieChart extends Component {

    constructor(props) {
        super(props);
        // this.state = {
        //     dataProvider: generateData(),
        //     timer: null
        // };
    }

    componentDidMount() {
        // this.setState({
        //     // Update the chart dataProvider every 3 seconds
        //     timer: setInterval(() => {
        //         this.setState({
        //             dataProvider: generateData()
        //         });
        //     }, 40000)
        // });
        // console.log(this.state.dataProvider);

    }
    componentWillUnmount() {
        // clearInterval(this.state.timer);
    }

    render() {
        const config = {
            "type": "pie",
            "legend": {

                "enabled": true,
                "position":"right",
                "valueWidth":60,
                "verticalGap":1,
                "markerSize":10,
                "markerLabelGap":3,
                "truncateLabels":30,
                "valueText": "[[percents]]%",
                "fontSize":9,
            },
            "groupPercent": 1,
            "theme": "default",
            "dataProvider": this.props.data,
            "valueField": this.props.y_axis,
            "titleField": this.props.x_axis,
            "outlineAlpha": 0.1,
            "radius": "35%",
            "labelRadius": 5,
            "fontSize":9,
            "colors": ["#2196f3","#ff9900","#109618","#aaaa11","#651067","#FFFF00","#5574a6","#b77322","#3b3eac","#a9c413","#2a778d","#668d1c","#bea413","#0c5922","#743411"],
            "balloon":{
                "fixedPosition":true,
            },
            "export": {
                "enabled": true
            }

        };
        return (
            <div >
                <AmCharts.React style={{ width: "100%", height: "250px" }} options={config} />
            </div>
        );
    }
}

export default PieChart;